export enum ItemConditionEnum {
  NEW = 'NEW',
  USED = 'USED',
}
